import React from 'react'
import { Button, Modal } from 'react-bootstrap'

export default function CommaonModal({ show, onCloseModal, title, timer, onStayLoggedIn, onLogout }) {
    return (
        <Modal
            className="rounded-lg"
            show={show}
            // onHide={onCloseModal}
            aria-labelledby="contained-modal-title-vcenter"
            centered
            size="md"
        >
            <Modal.Header className="d-flex justify-content-center">
                <Modal.Title as="h5" className="mb-0">{title}</Modal.Title>
            </Modal.Header>
            <Modal.Body className="text-center px-4 pb-4">
                <div className="d-grid gap-3">
                    <div className="p-3 bg-light rounded">
                        You will be logged out in <strong>{timer} second{timer !== 1 ? 's' : ''}</strong> due to inactivity.
                        Please choose to <strong>Stay Logged in</strong> or to Logout. Otherwise you will be Logged out automatically.
                    </div>
                    <div className="container">
                        <div className="row">
                            <div className="col">
                                <Button
                                    className='edu-btn btn-small w-75 my-2'
                                    onClick={onStayLoggedIn}
                                >
                                    Stay Logged in
                                </Button>
                            </div>
                            <div className="col">
                                <Button
                                    className='edu-btn btn-small w-75 my-2 bg-danger'
                                    onClick={onLogout}
                                >
                                    LogOut!
                                </Button>
                            </div>
                        </div>
                    </div>
                </div>
            </Modal.Body>
        </Modal>
    );
}
